import Revise from './reviseStep';

export default {
  spouseExists(testator) {
    return testator.testatorRelationships.find(tr => tr.relation == 'SPOUSE');
  },
  childExists(testator) {
    return testator.testatorRelationships.find(tr => tr.relation == 'CHILD');
  },
  childGuardianExists(testator) {
    return testator.testatorRelationships.find(
      tr => tr.relation == 'CHILD_GUARDIAN'
    );
  },
  childrenTrustSectionCompleted(testator) {
    if (testator.willCountry == 'GB') {
      return true;
    }
    if (
      testator.hasChildren === false ||
      testator.createChildrensTrust === false
    ) {
      return true;
    }
    return (
      testator.hasChildren &&
      testator.createChildrensTrust &&
      testator.trustTerminationAge &&
      this.trusteeExists(testator)
    );
  },
  trusteeExists(testator) {
    return (
      testator.testatorRelationships.find(tr => tr.relation == 'TRUSTEE') ||
      testator.companyIsTrustee
    );
  },
  emergencyContactsExist(testator) {
    return testator.testatorRelationships.find(
      tr => tr.relation == 'EMERGENCY_CONTACT'
    );
  },

  peopleWizardLocation(testator) {
    if (testator.maritalStatus == null) {
      return '/people/married';
    } else if (testator.isMarried && !this.spouseExists(testator)) {
      return '/people/spouse';
    } else if (
      testator.isMarried &&
      this.spouseExists(testator) &&
      !this.isGBWill &&
      !testator.maritalRegime
    ) {
      return '/people/marital-regime';
    } else if (testator.hasChildren == null) {
      return '/people/children';
    } else if (testator.hasChildren && !this.childExists(testator)) {
      return '/people/add-children';
    } else if (testator.hasChildren && !this.childGuardianExists(testator)) {
      return '/people/guardian';
    } else if (!this.childrenTrustSectionCompleted(testator)) {
      return '/people/trust';
    } else if (!this.emergencyContactsExist(testator)) {
      return '/people/emergency-contacts';
    } else if (!testator.hasExecutor) {
      return '/people/executor';
    } else {
      return 'people/married';
    }
  },
  step6Title(testator) {
    return testator.willCountry == 'ZA'
      ? 'Living Will & Letter of wishes'
      : 'Letter of wishes';
  },

  getCalculatedSteps(testator, testatorSteps, enabledFeatures, images) {
    if (
      testator === undefined ||
      testatorSteps === undefined ||
      enabledFeatures === undefined ||
      images === undefined
    ) {
      return [];
    }
    var steps = [
      {
        stepNumber: 1,
        id: 'about-yourself',
        title: 'About yourself',
        text: 'Tell us who you are.',
        image: images.overviewStep1,
        estimatedTime: '1min',
        redirectLocation: '/about-yourself',
        editLocation: '/about-yourself',
        show: true,
        completed: testatorSteps.aboutYourself,
        revise: Revise.reviseStep(testator, 1),
        style: 'default',
      },
      {
        stepNumber: 2,
        id: 'your-people',
        title: 'Your people',
        text: enabledFeatures.includes('om_only_executor')
          ? 'Tell us about your family, who you would like to appoint as guardians of your children.'
          : 'Tell us about your family, who you would like to appoint as Executor of your estate, guardians of your children.',
        image: images.overviewStep2,
        estimatedTime: '2-5min',
        redirectLocation: this.peopleWizardLocation(testator),
        editLocation: '/people-overview',
        show: testatorSteps.aboutYourself,
        completed: testatorSteps.people,
        revise: Revise.reviseStep(testator, 2),
        style: 'default',
      },
      {
        stepNumber: 3,
        id: 'your-assets',
        title: 'Your assets',
        image: images.overviewStep3,
        text: 'List your assets here, like properties, vehicles, investments and other significant assets.',
        estimatedTime: '1-2min',
        redirectLocation: '/world-wide-assets',
        editLocation: '/world-wide-assets',
        show: testatorSteps.people,
        completed: testatorSteps.assets,
        revise: Revise.reviseStep(testator, 3),
        style: 'default',
      },
      {
        stepNumber: 4,
        id: 'specific-donations',
        title: 'Specific bequests',
        text: 'Specific assets or amounts of money you wish to leave to specific people.',
        image: images.overviewStep4,
        estimatedTime: '2-5min',
        redirectLocation: '/specific-donations',
        editLocation: '/specific-donations',
        show: testatorSteps.assets,
        completed: testatorSteps.specificDonations,
        revise: Revise.reviseStep(testator, 4),
        style: 'default',
      },
      {
        stepNumber: 5,
        id: 'remainder-of-estate',
        title: 'Remainder of estate',
        text: 'Tell us how you want to distribute the rest of your assets that remain in your estate after you have made specific donations (if any).',
        image: images.overviewStep5,
        estimatedTime: '2-5min',
        redirectLocation: '/remainder-of-estate/distribution',
        editLocation: '/remainder-of-estate/distribution',
        show: testatorSteps.specificDonations,
        completed: testatorSteps.remainderOfEstate,
        revise: Revise.reviseStep(testator, 5),
        style: 'default',
      },
      {
        stepNumber: 6,
        id: 'letter-of-wishes',
        title: this.step6Title(testator),
        text: 'Tell us about your specific instructions to help your Executor manage your wishes to the best of their ability.',
        image: images.overviewStep6,
        estimatedTime: '1-2min',
        redirectLocation: '/letter-of-wishes',
        editLocation: '/letter-of-wishes',
        show: testatorSteps.remainderOfEstate,
        completed: testatorSteps.letterOfWishesAndLivingWill,
        revise: Revise.reviseStep(testator, 6),
        style: 'default',
      },
    ];

    const insuranceLocation = enabledFeatures.includes('omp_financial_data_sq')
      ? '/insurance/old-mutual-protect'
      : '/insurance/explanation';
    const insuranceStep = {
      stepNumber: 7,
      id: 'insurance',
      title: 'Protect your estate',
      text: 'Can you afford the costs (legal and administration fees) associated with winding up your estate?',
      image: images.overviewStep7,
      estimatedTime: '1-2min',
      redirectLocation: insuranceLocation,
      editLocation: insuranceLocation,
      show: testatorSteps.letterOfWishesAndLivingWill,
      completed: testatorSteps.insurance,
      revise: Revise.reviseStep(testator, 7),
      style: 'default',
    };
    if (
      enabledFeatures.length &&
      (enabledFeatures.includes('full_insurance') ||
        enabledFeatures.includes('liquidity_calculator') ||
        enabledFeatures.includes('advisor_full_insurance') ||
        enabledFeatures.includes('omp_financial_data_sq')) &&
      testator.willCountry == 'ZA'
    ) {
      steps.push(insuranceStep);
    }
    return steps;
  },
};
